<template>
<div class="chapter">
<div class="inner_page">
<h1>Points of Departure</h1>
<h4 class="sigil_not_in_toc" style="text-align: center;">Liavek stories</h4>
<h3 class="sigil_not_in_toc">By Patricia C. Wrede<br/>
  &amp; Pamela Dean</h3>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0001.vue?3498e588